<template>
  <!--2图文 -->
  <div class="article-section" @click="go(dataItem)">
    <img :src="dataItem.cover_img" class="article-section-img"/>
    <div class="article-section-content">
      <div class="article-section-content-title">{{ dataItem.title }}</div>
      <div class="article-section-content-detail" v-if="dataItem.type == 2">
        共{{ dataItem.total_count }}篇
        <span style="margin-left: 5px">{{ dataItem.view_count }}人阅读</span>
      </div>
      <div class="article-section-content-detail" v-else>
        {{ dataItem.view_count }}人阅读
      </div>
    </div>
  </div>
</template>

<script>
import Interface from '@/util/interface'
export default {
  name: "article",
  props: {
    dataItem: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      // applyShow: false
    }
  },
  methods: {
    go(row) {
      if (row.type == 2) {
        this.$router.push({ name: 'article-column', params: { id: row.origin_id } })
      } else {
        this.$router.push({ name: 'article-detail', params: { id: row.origin_id } })
      }
        Interface.mFootPrint(row.origin_id,2,0,5,0, row.title)
    }
  }
}
</script>

<style scoped lang="scss">
.article-section{
  padding-bottom: 16px;
  &-img{
    width: 100%;
    height: 102px;
    background: linear-gradient(180deg, #ECEFF6 0%, #D7DFF3 100%);
    border-radius: 6px;
  }
  .van-image__img{
    width: 180px;
    height: 102px;
    border-radius: 6px;
  }
  &-content{
    height: 62px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 12px 0 0 0;
    &-title{
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #222222;
      line-height: 20px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
    }
    &-detail{
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #979797;
      &-btn{
        font-size: 13px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #D81D20;
        padding: 3px 7px;
        background: #FFF0EE;
        border-radius: 17px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/horizontalRecommend/article.vue